import FormJaivana from "dashboard_jaivana_v1";
/**
 * @description: CustomCambiarContrasena
 * @author: Santiago Hernández N
 * @version: jdesk_1.01.0009.1
 **/


class CustomCambiarContrasena extends FormJaivana.form {
  constructor(props) {
    super(props);
    this.initForm                           = this.initForm.bind(this);
    this.AceptarCambio                      = this.AceptarCambio.bind(this);
    this.CancelarCambio                     = this.CancelarCambio.bind(this);
    this.limpiarCampos                      = this.limpiarCampos.bind(this);
    this.validatePassword                   = this.validatePassword.bind(this);
    this.sugerirContrasena                  = this.sugerirContrasena.bind(this);
    this.guardarContrasena                  = this.guardarContrasena.bind(this);
    this.successGuardarPsw                  = this.successGuardarPsw.bind(this);
    

  }

  initForm() {
    console.log("Formulario CustomCambiarContrasena,  @version: jdesk_1.01.0009.1, @author: Santiago Hernández N");

      this.getField("txt_informativo").setVisible(false);
      this.getField("guardar").setVisible(false);

      this.getField('buscador_usuario').setValue(JSON.parse(localStorage.getItem('res')).codigo); 
      this.getField('nombre_usuario').setValue(JSON.parse(localStorage.getItem('res')).nombre);
      this.getField('usuario_id').setValue(JSON.parse(localStorage.getItem('res')).id); 

      this.getField('buscador_usuario').setDisabled(true); 
      this.getField('nombre_usuario').setDisabled(true);; 


      this.getField('nombre_usuario').setOnChange(()=>{
        if (this.getField('nombre_usuario').getValue() === '' || this.getField('nombre_usuario').getValue() === ' ') {
          this.getField('psw_actual').setError(false,'');
          this.getField('psw_nueva').setError(false,''); 
          this.getField('psw_nueva_confirmar').setError(false,'');
          this.getField('psw_actual').setValue('');
          this.getField('psw_nueva').setValue(''); 
          this.getField('psw_nueva_confirmar').setValue('');
          this.getField('txt_informativo').setVisible(false);
          this.getField('txt_informativo').setValue('');
        }
      });      
      this.getField('psw_actual').setOnChange((props) => {         
        if (this.getField('psw_actual').getValue() === '' || this.getField('psw_actual').getValue() === ' ') {
            
        } else {
            this.getField('psw_actual').setTypePassword(true);
        }
      });

      this.getField('psw_nueva').setOnChange((props) => { 
        if (this.getField('psw_nueva').getValue() === '' || this.getField('psw_nueva').getValue() === ' ') {
          
        } else {
            if(this.getField('psw_nueva').valid()){
              this.getField('psw_nueva').setError(false,'')
            }
            this.getField('psw_nueva').setTypePassword(true);            
        }
      });


      this.getField('psw_nueva_confirmar').setOnChange((props) => {       
        if (this.getField('psw_nueva_confirmar').getValue() === '' || this.getField('psw_nueva_confirmar').getValue() === ' ') {

        } else {
            if(this.getField('psw_nueva_confirmar').valid()){
              this.getField('psw_nueva_confirmar').setError(false,'')
            }
            this.getField('psw_nueva_confirmar').setTypePassword(true);            
        }
      });

      this.getField('sugerir').setClick(()=>{       
        this.sugerirContrasena();
      });

      this.getField('aceptar').setClick(()=>{       
        this.AceptarCambio();
      });

      this.getField('cancelar').setClick(()=>{       
        this.CancelarCambio();
      });

      this.getField('guardar').setClick(()=>{       
        this.guardarContrasena();
      });
      
  }


  AceptarCambio(){

    if (this.getField("buscador_usuario").valid() && this.getField("psw_actual").valid() && this.getField("psw_nueva").valid() && this.getField("psw_nueva_confirmar").valid()){
      
      this.getField("txt_informativo").setValue('');
      this.getField("txt_informativo").setVisible(false);
      this.validatePassword(this.getField("psw_nueva_confirmar").getValue());
      
    }else{
      this.getField('fieldAlert').toggle(true, 'Error validando los campos', "error");
    }

  }

  CancelarCambio(){

    this.limpiarCampos();

  }

  limpiarCampos(){
    this.getField('buscador_usuario').setValue(JSON.parse(localStorage.getItem('res')).codigo); 
    this.getField('nombre_usuario').setValue(JSON.parse(localStorage.getItem('res')).nombre); 
    this.getField('usuario_id').setValue(JSON.parse(localStorage.getItem('res')).id); 
    this.getField("psw_actual").setValue('');
    this.getField("psw_nueva").setValue('');
    this.getField("psw_nueva_confirmar").setValue('');
    this.getField("txt_informativo").setValue('');
    
    
    this.getField('buscador_usuario').setError(false, '');
    this.getField('psw_actual').setError(false, '');
    this.getField('psw_nueva').setError(false, '');
    this.getField('psw_nueva_confirmar').setError(false, '');
    this.getField("nombre_usuario").setError(false, '');


    this.getField("txt_informativo").setVisible(false);
    this.getField("guardar").setVisible(false);

  }



  validatePassword(password) {
    var mensaje = "";
    this.getField("guardar").setVisible(false);
      
    if (password.includes(this.getField("nombre_usuario").getValue())) {
      mensaje = mensaje + "\n" + "La contraseña no debe contener el nombre de usuario.";
      this.getField("txt_informativo").setValue(mensaje);
      this.getField("txt_informativo").setVisible(true);
      return;
    }

    if (password !== this.getField("psw_nueva").getValue()) {
      mensaje = mensaje + "\n" + "Las contraseñas no coinciden.";
      this.getField("txt_informativo").setValue(mensaje);
      this.getField("txt_informativo").setVisible(true);
      return;
    }
    
    var conditions = [
      { regex: /[$@$!%*#?&]/, message: "La contraseña debe contener un carácter especial." },
      { regex: /[A-Z]/, message: "La contraseña debe contener una letra mayúscula." },
      { regex: /[0-9]/, message: "La contraseña debe contener un número." },
      { regex: /[a-z]/, message: "La contraseña debe contener una letra minúscula." },
      { regex: /^\S+$/, message: "La contraseña no debe contener espacios." },
      { regex: /.{8,15}/, message: "La contraseña debe contener entre 8 y 15 caracteres." }
    ];
    
    var ctr = 0;
    
    conditions.forEach(condition => {
      if (condition.regex.test(password)) {
        ctr++;
      } else {
        mensaje = mensaje + "\n" + condition.message;
      }
    });
    
    var strength = "";
    var color = "";
    
    switch (ctr) {
      case 0:
      case 1:
      case 2:
        strength = "Contraseña Débil";
        color = "error";
        break;
      case 3:
        strength = "Contraseña Débil";
        color = "error";
        break;
      case 4:
        strength = "Contraseña Regular";
        color = "warning";
        break;
      case 5:
        strength = "Contraseña Regular";
        color = "warning";
        break;
      case 6:
        strength = "Contraseña Fuerte";
        color = "success";        
        this.getField("guardar").setVisible(true);
        break;
    }

    this.getField('fieldAlert').toggle(true, strength, color);
    if(mensaje===''){
      this.getField("txt_informativo").setVisible(false);
    }else{
      this.getField("txt_informativo").setVisible(true);
      this.getField("txt_informativo").setValue(mensaje);
    }

  }

  sugerirContrasena(){
    
    if (this.getField("buscador_usuario").valid() && this.getField("psw_actual").valid()){
      const caracteresEspeciales = "$@$!%*#?&";
      const letrasMayusculas = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const letrasMinusculas = "abcdefghijklmnopqrstuvwxyz";
      const numeros = "0123456789";

      let contraseña = "";
      contraseña += caracteresEspeciales.charAt(Math.floor(Math.random() * caracteresEspeciales.length));
      contraseña += letrasMayusculas.charAt(Math.floor(Math.random() * letrasMayusculas.length));
      contraseña += letrasMinusculas.charAt(Math.floor(Math.random() * letrasMinusculas.length));
      contraseña += numeros.charAt(Math.floor(Math.random() * numeros.length));
      const todosLosCaracteres = caracteresEspeciales + letrasMayusculas + letrasMinusculas + numeros;
      for (let i = contraseña.length; i < 15; i++) {
        contraseña += todosLosCaracteres.charAt(Math.floor(Math.random() * todosLosCaracteres.length));
      }
      contraseña = contraseña.split('').sort(() => Math.random() - 0.5).join('');
    
      const longitudContraseña = Math.floor(Math.random() * (15 - 8 + 1)) + 8;
      contraseña = contraseña.substring(0, longitudContraseña);
      if (/[$@$!%*#?&]/.test(contraseña) && /[A-Z]/.test(contraseña) && /[0-9]/.test(contraseña) && /[a-z]/.test(contraseña) && !/\s/.test(contraseña) && contraseña.length >= 8 && contraseña.length <= 15) {
        this.getField("psw_nueva").setValue(contraseña);
        this.getField("psw_nueva_confirmar").setValue(contraseña);
      }     
    }
  }

  guardarContrasena(){

    if (this.getField("buscador_usuario").valid() && this.getField("psw_actual").valid() && this.getField("psw_nueva").valid() && this.getField("psw_nueva_confirmar").valid()){
      this.getField('guardar').setDisabled(true);
      let datos = { 
        datos: {
          usuario_id: Number(this.getField('usuario_id').getValue()),
          pswactual: this.getField("psw_actual").getValue(),
          pswnueva: this.getField("psw_nueva_confirmar").getValue()
        }
      };
          
      this.generalFormatPmv = { tipo_servicio: 'heus-cambiocontrasena', operacion: 'guardarcontrasena', operacion_tipo: 'modificar' };
      this.service.send(
      {
              endpoint: this.constant.formConfiguration(),
              method:'PUT',
              body: datos,
              success: this.successGuardarPsw,
              error: this.error_,
              general: this.generalFormatPmv
      });

    }else{

      this.getField('fieldAlert').toggle(true, 'Error validando los campos', "error");

    }

  }

  successGuardarPsw(data){
    if(data.estado_p === 200){
      this.limpiarCampos();
      this.getField('guardar').setDisabled(false);
    } else{
      this.getField('guardar').setDisabled(false);
      let respuesta=Object.values(data.data.mensaje);
      this.alertGeneral.toggle(true, respuesta, 'error');
    }
  }
    
}
FormJaivana.addController("heus-cambiocontrasena", CustomCambiarContrasena);
export default CustomCambiarContrasena;